import { render, staticRenderFns } from "./SettingsFont.vue?vue&type=template&id=dff5863a&"
import script from "./SettingsFont.vue?vue&type=script&lang=js&"
export * from "./SettingsFont.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports